
<mat-card class=" memberPartern mt-3">
    
    <mat-card-header>
      <mat-card-title class="">{{teamdata.teamName}}</mat-card-title>
      <mat-card-subtitle class="age">Team Level: {{teamdata.teamType}} people</mat-card-subtitle> 
    </mat-card-header>
     
    <mat-card-content>
       <app-team-details [teamdata1]="teamdata" [screentype] = "1"></app-team-details>
    </mat-card-content>
    <mat-card-actions class="mt-4  ">
        <a mat-button class="ml-3 callIcon"  (click)="deleteTeam(teamdata.teamId)"><img mat-card-image class="bloodIcon" src="assets/img/deleteIcon.png" /></a>
      
        <button *ngIf="isAdmin" class="memberDashboard1" (click)="assignMembers(teamdata.teamId)"  mat-button>Assign Member</button>
        <button class="memberDashboard1" (click)="viewMember(teamdata.teamId)"  mat-button>View Members</button>
        <button class="memberDashboard" (click)="viewTeamDetails(teamdata.teamId)" mat-button>View Details</button>
    </mat-card-actions>
  </mat-card>
